export default {
    900008: 'Hello, your operation is too frequent, please try again later',
    900005: 'The resource no longer exists',
    900004: 'File type is not supported',
    900003: 'File size exceeds limit',
    900002: 'The format is wrong',
    900001: 'Attribute value is required',
    900000: 'Verification failed, please try again',
    20106: 'The phone number has been occupied, please input again',
    20105: 'The mailbox has been occupied, please input again',
    20138: 'The one-time verification code expires and may have been bound to the mailbox. Please re-bind the mailbox.',
    1: 'Operation failed, you do not have this permission',
    2: 'The operation failed. Please try again later',
    3: 'The operation failed. Please try again later',
    40208: 'You have already scored it!',
    10138: '没有权限',
    100316: '直播已结束',
    100315: '开始时间小于当前, 不允许发布',
    100034: '直播讲师超出最大人数限制',
    100313: '第三方直播不存在',
    40324: '直播讲师无法删除',
    100321: '直播云请求失败',
    100326: '直播不允许此操作',
    504: '请求超时',
    910001: 'The data type is wrong',
    910003: 'Required fields',
    910002: 'Exceed length limit',
    30142: 'Unauthorized exam access',
    90901: 'Your account has been logged in on another device or browser. Please login again',
    10202: 'Have reported, please wait for the review!',
    90902: 'Your account has been logged in on another device, please login again',
    30148: 'Must pass the exam before viewing the details',
    10203: "The resources you'd like to report no longer exist!",
    900009: 'Hello, your operation is too frequent today, please come back tomorrow',
    990001: 'Upload failed, the image size cannot be greater than 5M',
    21901: 'The receiving address has reached the upper limit.',
    21902: 'There is no right to operate the receipt address.',
    20147: 'Email verification code expired',
    20146: 'Please add a mobile phone or email first',
    20134: 'Invalidate verification code',
    20133: 'Mobile verification code is empty',
    20150: 'The mailbox is empty',
    201502: 'File cannot be empty',
    10134: 'message failed to be sended',
    90903: 'Log in too many times, the account has been restricted, please log in later',
    20149: 'Mobile number is empty',
    21903: 'File service exception, please try again.',
    21904: '文件上传异常',
    40323: '配置推送内容和学员均为必填项',
    20102: 'The licence number is repetitive',
    40210: 'document no translate success',
    40214: 'The cut-off time must not be less than the current time',
    41102: '学习包推送内容数量或附件数量过多',
    85009: 'There is already a lucky draw for the points store. Please cancel other events first.',
    85006: 'At least one thank you for participating',
    85005: 'Award probability and need equal to 1',
    86006: 'Inbound information is incomplete',
    85008: 'The lucky draw cannot be revoked as its status is opening',
    86007: 'Prize cannot be redeemed',
    85007: "The status of lucky draw isn't opening",
    86004: 'No draws',
    85002: 'Cannot delete the opening draw.',
    86005: 'No lucky draw(No more chances for free lucky draw or insufficient points)',
    85001: 'The luck draw cannot be deleted as it is in use.',
    86002: 'Activity is not in the time range',
    85004: 'Incorrect prize quantity.',
    86003: 'Please select a lottery strategy.',
    85003: 'The draw does not exist or has been removed.',
    86001: 'Cannot find the id of the draw',
    86008: 'The event is over and cannot be modified',
    86009: 'Audience item cannot be empty',
    85013: 'It is not allowed to modify the active style after the event has been published once.',
    85012: 'Illegal number of winners',
    86013: 'Awards cannot be deleted',
    86011: 'The event is over',
    86012: 'The resource no longer exists',
    85011: 'The prize has been distributed',
    85010: 'The number of awards is less than the number of draws',
    86010: 'Insufficient lottery',
    86014: 'Award information not filled in',
    86015: 'You are not authorized to participate in the event',
    86016: 'You have scanned the code and successfully',
    86017: 'You are not authorized to participate in the event',
    40109: 'There must be a required content to publish',
    60201: 'You are not a lecturer or your lecturer status is disabled',
    34008: 'The exam has been reset by the administrator',
    39011: 'The examination record parameter is missing, if has the question, please contact the administrator!',
    39012: 'You can view the test paper after the exam is over. If you have any questions, please contact the administrator!',
    39013: 'After passing the exam, you can check the test paper. If you have any questions, please contact the administrator!',
    70118: 'This content has been edited and cannot be reviewed',
    70899: 'No delete permission',
    70111: 'This content no longer exists',
    70110: 'This content has been unpinned',
    70109: 'This content has been pinned',
    70307: "This expert's status has been frozen and cannot be viewed.",
    70108: 'The content has been deprived of highlighting',
    70306: 'Your expert status has been frozen',
    70105: 'This content has been closed',
    70204: 'The discussion has been pinned',
    70303: 'You are already an expert and are not allowed to apply again',
    70402: "The resources you'd like to report no longer exist!",
    70104: 'The content has been closed and cannot be discussed',
    70203: 'The discussion has been deprived of highlighting',
    70302: 'You have already submitted an expert application, please do not submit again',
    70401: 'You have already reported this content, the administrator is reviewing, please do not repeat the report',
    70107: 'The content has been highlighted',
    70206: 'This comment no longer exists',
    70305: 'Your topic change request is under review and you are not allowed to apply again',
    70503: 'Audit resource does not exist',
    70106: 'This content has been activated',
    70205: 'The discussion has been unpinned',
    70304: 'You are not an expert',
    70502: 'Reviewed',
    70101: "This post can't be deleted for some people have followed",
    70103: "This post can't be deleted for some people have discussed",
    70202: 'The discussion has been highlighted',
    70301: 'Your organization does not have an expert qualification configuration',
    70102: "This post can't be deleted for some people have shared",
    70201: "This post can't be deleted for some people have replied",
    70120: 'This question already exists. Please post it again after changing the title.',
    70119: 'This content has been reported and cannot be edited',
    70999: 'The operation is too frequent, please try again later',
    70122: 'This content has been edited and cannot be reviewed',
    900920: "Resources don't exist",
    70207: '暂不支持发表言论',
    60131: '该班级已经结项',
    60139: '该班级已经撤销',
    64104: '班级不存在',
    15006: '审批节点异常，请联系管理员',
    701011: '额度不足，分配失败',
    701012: 'currency is not enough',
    701013: '额度不足，专栏订阅失败',
    700404: 'The divergent number has been concerned, do not repeat attention',
    700303: 'The invide code is not exsit',
    700501: 'The column is not exist',
    700502: 'The column has been subscribed , can not delete',
    700307: 'You can delete  the column only by you created ',
    700402: 'The content is connented by other column',
    700503: 'Unauthorized to update the column',
    700504: 'Unauthorized to delete the column',
    20161: 'Not subordinate'
};
